import { ModalBoxUtils } from "../../../@admin/utils/constant";

export interface ManagePortalsResponse {
  serviceType: number | null;
  title?: string | null;
  description?: string | null;
  isDisabled?: boolean;
}

export enum ServiceType {
  CAPPSPortal = 1,
  CountyAdminPortal = 2,
  Documentation = 3,
  General = 4,
}

export interface CommonFilterButton {
  isVisible?:boolean
  label?:string,
  tooltip?: string,
  icon?: string,
  actionDetails: ModalBoxUtils,
}


export interface ApplicationResponse {
  extraProperty: null,
  count?: number,
  totalCount?: number,
  page?: number,
  pageSize?: number,
  items?: ApplicationDetails[],
}

export interface ApplicationDetails {
  id?: number,
  statusEnum?: number,
  countyId?: number,
  countyName?: string,
  referenceNumber?: string,
  taxPayerName?: string,
  parcelNumber?: string,
  parcelAddress?: string,
  ownerOfRecord?: string,
  propertyAddress?: string,
  mailingAddress?: string,
  contactNo?: string,
  email?: string,
  taxYear?: string,
  status?: string,
  deedBook?: string,
  deedPage?: string,
  deedFileName?: string,
  uploadedOnDisplay?: string
}

export interface ApplicationsDetailsFilter {
  statusEnum?: string | null,
  fileStatusEnum?: number | null,
  taxYear?: number | null,
  countyId?:number | null,
  isActive?:boolean
}
